export const CONFIRM_INSTANT_CHECKOUT = 'waitrose/instant-checkout/CONFIRM_INSTANT_CHECKOUT';

export const STARTED_INSTANT_CHECKOUT = 'waitrose/instant-checkout/STARTED_INSTANT_CHECKOUT';

export const FINISHED_INSTANT_CHECKOUT = 'waitrose/instant-checkout/FINISHED_INSTANT_CHECKOUT';
